"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOrApiAuthHeadersSchema = exports.UserAuthHeadersSchema = exports.USER_AUTH_HEADER_NAME = exports.ApiAuthHeadersSchema = exports.INTERNAL_SERVICE_IP_ADDRESS = exports.API_AUTH_ORIGIN_IP = exports.API_AUTH_ACTOR_HEADER_NAME = exports.AUTHENTICATED_API_AUTH_COURT_SYSTEM_ID = exports.API_AUTH_HEADER_NAME = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
exports.API_AUTH_HEADER_NAME = 'x-api-key';
exports.AUTHENTICATED_API_AUTH_COURT_SYSTEM_ID = 'x-authenticated-court-system-id';
exports.API_AUTH_ACTOR_HEADER_NAME = 'x-api-actor';
exports.API_AUTH_ORIGIN_IP = 'x-api-origin-ip';
exports.INTERNAL_SERVICE_IP_ADDRESS = '127.0.0.1';
exports.ApiAuthHeadersSchema = zod_1.default
    .object({
    [exports.API_AUTH_HEADER_NAME]: zod_1.default.string().optional(),
    [exports.AUTHENTICATED_API_AUTH_COURT_SYSTEM_ID]: zod_1.default.string().uuid().optional(),
    [exports.API_AUTH_ACTOR_HEADER_NAME]: zod_1.default.enum(['court-system-api-key', 'internal-service']).optional(),
    [exports.API_AUTH_ORIGIN_IP]: zod_1.default.string().ip().optional(),
})
    .transform(data => {
    return { ...data, type: 'apiKey' };
});
exports.USER_AUTH_HEADER_NAME = 'authorization';
exports.UserAuthHeadersSchema = zod_1.default.object({ [exports.USER_AUTH_HEADER_NAME]: zod_1.default.string().optional() }).transform(data => {
    return { ...data, type: 'user' };
});
exports.UserOrApiAuthHeadersSchema = zod_1.default
    .unknown()
    .transform(data => {
    const parsedUser = exports.UserAuthHeadersSchema.parse(data);
    const parsedApi = exports.ApiAuthHeadersSchema.parse(data);
    if (parsedUser[exports.USER_AUTH_HEADER_NAME] && parsedApi[exports.API_AUTH_HEADER_NAME]) {
        throw new Error('Cannot have both user and api auth headers');
    }
    if (parsedUser[exports.USER_AUTH_HEADER_NAME]) {
        return parsedUser;
    }
    return parsedApi;
})
    .transform(data => ({ ...data, _brand: 'userOrApiAuth' }));
